const RelatedRecipes = () => {
  const relatedRecipes = document.querySelectorAll('[related-recipes]')
  relatedRecipes.forEach(element => {
    const data = element.dataset;
    if (data.url !== undefined && data.url !== '') {
      fetch(data.url)
        .then(response => response.text())
        .then(html => {
          element.querySelector('.result-container').innerHTML = html;
        });
    }
  });
};

export default RelatedRecipes;